<template>
  <div class="CartSummary">
    <div class="totalOrderNum">
      合計数量<span class="value">{{ totalOrderNum.toLocaleString() }}</span>
    </div>
    <div class="merchandiseAmount">
      注文金額<span class="value">{{ merchandiseAmount.toLocaleString() }}</span
      >円
    </div>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from "#app";

export default defineNuxtComponent({
  props: {
    totalOrderNum: {
      type: Number,
      default: 0,
    },
    merchandiseAmount: {
      type: Number,
      default: 0,
    },
  },
});
</script>

<style scoped>
.CartSummary {
  background-color: var(--semantic-colors-background-lightgray);
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  line-height: 18px;
  letter-spacing: 0.11px;
}

.totalOrderNum,
.merchandiseAmount {
  display: flex;
  align-items: center;
}

.CartSummary .value {
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.32px;
}

.totalOrderNum .value {
  margin-left: 4px;
}

.merchandiseAmount .value {
  margin-left: 8px;
  margin-right: 4px;
}
</style>
